// extracted by mini-css-extract-plugin
module.exports = {"link":"Helptext_link__3_8C-"};